<!--监测点弹框-->

<template>
  <Modal :visible.sync='show'  :title="$t('integration.mounting_details')" @close='show=false'>
    <el-form :model='carrierInfo' v-loading='loading'>
      <el-row v-if='carrierInfo'>
        <el-col :span='12'>
          <el-form-item :label="$t('integration.label_carrier_name')">{{carrierInfo.keycode}}</el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item :label="$t('integration.monitoring_point_type')">
            <i v-icon="['carrierTypeConvert',carrierInfo.typeId]"></i>
            {{ carrierInfo.typeName }}
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item :label="$t('public.mode')">{{ $t(carrierMode[carrierInfo.mode || 1].title) }}</el-form-item>
        </el-col>
        <el-col :span='12' v-if='carrierInfo.mac'>
          <el-form-item :label="$t('integration.mac_address')">{{ carrierInfo.mac }}</el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item :label="$t('public.belong_customer')">{{ carrierInfo.fullPath }}</el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item :label="$t('public.belong_arch')">{{carrierInfo.structureName}}</el-form-item>
        </el-col>

        <el-col :span='12'>
          <el-form-item :label="$t('public.status')">
              <div style='height: 28px'>
                <i v-icon="['carrierStatusConvert',carrierInfo.status]"></i>
                {{carrierInfo.statusName}}
              </div>
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <el-form-item :label="$t('integration.alarm_switch')">{{ $t(alarm[carrierInfo.alarm_switch].title) }}</el-form-item>
        </el-col>

        <el-col :span='12'>
          <el-form-item :label="$t('integration.creation_time')">{{$timetransition(carrierInfo.create_time)}}</el-form-item>
        </el-col>

        <el-col :span='12'>
          <el-form-item :label="$t('integration.describe')">{{carrierInfo.description}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template #footer>
      <el-button type='primary' @click='show=false' >{{$t('public.btn_close')}}</el-button>
    </template>
  </Modal>
</template>
<script>
import { alarm, carrierMode, carrierStatusConvert } from '@/utils/convert'
export default {
  props: {
    carrierInfo: {
      type: [Object, String],
      default: () => {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    carrierInfo () {
      this.loading = false
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.loading = true
        }
        this.$emit('update:visible', val)
      }
    }
  },
  data () {
    return {
      loading: false,
      alarm,
      carrierMode,
      carrierStatusConvert
    }
  }

}
</script>

<style scoped lang='scss'>

</style>
